



























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { IDelegate, ISortParameters, ITransaction } from "@/interfaces";
import CryptoCompareService from "@/services/crypto-compare";

@Component({
  computed: {
    ...mapGetters("network", ["activeDelegates", "isListed"]),
    ...mapGetters("currency", { currencySymbol: "symbol" }),
    ...mapGetters("ui", ["smartbridgeFilter"]),
  },
})
export default class LockTransactionsDesktop extends Vue {
  @Prop({
    required: true,
    validator: (value) => {
      return Array.isArray(value) || value === null;
    },
  })
  public transactions: ITransaction[] | null;

  private activeDelegates: IDelegate[];
  private isListed: boolean;
  private currencySymbol: string;
  private smartbridgeFilter: string;

  get columns() {
    const columns = [
      {
        label: this.$t("COMMON.ID"),
        field: "lockId",
        thClass: "start-cell",
        tdClass: "start-cell",
      },
      {
        label: this.$t("COMMON.EXPIRATION"),
        field: "expirationValue",
        type: "number",
        thClass: "text-left hidden md:table-cell",
        tdClass: "text-left hidden md:table-cell wrap-timestamp",
      },
      {
        label: this.$t("TRANSACTION.RECIPIENT"),
        field: "recipientId",
        tdClass: "break-all",
      },
      {
        label: this.$t("TRANSACTION.SMARTBRIDGE"),
        field: "vendorField",
        thClass: "text-right cell-smartbridge",
        tdClass: "text-right cell-smartbridge",
        hidden: this.smartbridgeFilter === "hidden",
      },
      {
        label: this.$t("TRANSACTION.AMOUNT"),
        field: "amount",
        type: "number",
        thClass: "end-cell",
        tdClass: "end-cell",
      },
    ];

    return columns;
  }

  get showSmartBridgeIcon() {
    if (this.smartbridgeFilter === "hidden") {
      return false;
    }

    return this.transactions!.some((transaction) => {
      return !!transaction.vendorField;
    });
  }

  @Watch("transactions")
  public async onTransactionsChanged() {
    await this.prepareTransactions();
  }

  @Watch("currencySymbol")
  public async onCurrencySymbolChanged() {
    await this.updatePrices();
  }

  public async created() {
    this.prepareTransactions();
  }

  private async prepareTransactions() {
    await this.updatePrices();
  }

  private async fetchPrice(transaction: ITransaction) {
    transaction.price = await CryptoCompareService.dailyAverage(transaction.timestamp.unix);
  }

  private async updatePrices() {
    if (!this.transactions) {
      return;
    }

    if (this.isListed) {
      const promises = this.transactions.map(this.fetchPrice);
      await Promise.all(promises);
    }
  }

  private emitSortChange(params: ISortParameters[]) {
    this.$emit("on-sort-change", params[0]);
  }
}
